import APIService from '@/services/APIService.js';

export default {
  getLotes(includeExpiredRecords) {
    return APIService.apiCall().get(`/logsUnitizacao/getLotes/${includeExpiredRecords}`);
  },

  getConsultas(includeExpiredRecords) {
    return APIService.apiCall().get(`/logsUnitizacao/getConsultas/${includeExpiredRecords}`);
  },

  getLote(id) {
    return APIService.apiCall().get(`/logsUnitizacao/getLote/${id}`);
  },

  getConsulta(id) {
    return APIService.apiCall().get(`/logsUnitizacao/getConsulta/${id}`);
  },

  uploadFile(postData) {
    return APIService.apiCall().post('/logsUnitizacao/upload', postData, {
      timeout: 60 * 60 * 1000,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  consultarChaves(postData) {
    return APIService.apiCall().post('/logsUnitizacao/consultarChaves', JSON.stringify(postData));
  },

  registrar(postData) {
    return APIService.apiCall().post('/logsUnitizacao/registrar', JSON.stringify(postData));
  },

  excluirLote(id) {
    return APIService.apiCall().get(`/logsUnitizacao/excluir/${id}`);
  },

  downloadConsulta(id, config = {}) {
    return APIService.apiCall().get(`/logsUnitizacao/baixarConsulta/${id}`, {
      responseType: 'blob',
      ...config
    });
  },

  downloadResultado(id, config = {}) {
    return APIService.apiCall().get(`/logsUnitizacao/baixarResultado/${id}`, {
      responseType: 'blob',
      ...config
    });
  },

  downloadRelatorioErros(id, config = {}) {
    return APIService.apiCall().get(`/logsUnitizacao/baixarRelatorioErros/${id}`, {
      responseType: 'blob',
      ...config
    });
  }
};
